import React, { useEffect, useState } from 'react'
import { Button, Input, DatePicker, Form, InputNumber, Select, Table, Popconfirm } from 'antd';
import { getItem, createItem, deleteItem } from '../../controller/Control';
import { LuTrash2 } from "react-icons/lu";
import type { FormProps } from 'antd';

interface Code {
	code: string;
	description: string;
}

const Codes: React.FC = () => {
    const [ dataCodes, setDataCodes] = useState<Code[]>([])
	const [ dataCodesFilter, setDataCodesFilter] = useState<Code[]>([])
	const [ codesActions, setCodesActions ] = useState({
		view: false,
		add: false,
		edit: false
	})
	const [form] = Form.useForm();
	

	const getData = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await getItem(`${process.env.REACT_APP_API_SERVER}/codes` || 'localhost:3000', token)
		setDataCodes(data)
	}

	useEffect(() => {
		getData()
	}, [0])

	useEffect(() => {
		getData()
	}, [codesActions])

	const createData = async(values: FormProps) => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const create = await createItem(`${process.env.REACT_APP_API_SERVER}/codes` || 'localhost:3000', values, token)
		if(create === 401){
			alert('Error General, o código ya creado, intente nuevamente')
		}
		if(create === 409){
			alert('Ya existe un código con el mismo número')
		}
		if(create._id){
			alert('Codigo creado con exito')
			form.resetFields();
			setCodesActions({view: false, add: false, edit: false})
		}
	}

	const handleSubmit = (values: FormProps) => {
		createData(values)
	}

    const deleteCode = async(data: any) => {
        const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const create = await deleteItem(`${process.env.REACT_APP_API_SERVER}/codes/${data._id}` || 'localhost:3000', token)
		if(create._id){
			getData()
		}
    }


	const columns = [
		{
			title: 'Código',
			dataIndex: 'code',
			key: 'code',
		},
		{
			title: 'Descripción',
			dataIndex: 'description',
			key: 'description',
		},
        {
            title: 'Eliminar',
            render: (a: any) => <Popconfirm 
                title="Seguro quiere eliminar este código?"
                description="Esta acción no se puede deshacer"
                cancelText="Cancelar"
                onConfirm={() => deleteCode(a)}
            >
                <LuTrash2 size={20} color='red' style={{cursor: 'pointer'}}/>
            </Popconfirm>

        }
	];

	return(
		<div className='px-5'>
			<div className='my-5 flex flex-col md:flex-row'>
				<div>
					{!codesActions.view ?
					<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' onClick={() => setCodesActions({view: true, add: true, edit: false})}>Agregar Código</button> : null}
				</div>
			</div>
			<div className='justify-center flex-col items-center patient' style={codesActions.view ? {display: 'flex'} : {display: 'none'}}>
				<h1 className='text-2xl text-text-menu my-5'>{codesActions.add ? 'Agrega un Código' : codesActions.edit ? 'Modificar un Código' : null}</h1>
				<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
					<Form
						layout='vertical'
						style={{maxWidth: 400}}
						onFinish={handleSubmit}
						form={form}
					>

						<Form.Item label="Código" name="code" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Descripción" name="description" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>
                        <Form.Item>
							<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' type="submit">
								Agregar
							</button>
							<button className='bg-text-menu ml-2 text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' onClick={() => setCodesActions({view: false, add: false, edit: false})}>
								Cancelar
							</button>
						</Form.Item>
					</Form>
				</div>
			</div>
			<div>
				<Table 
					dataSource={dataCodes} 
					columns={columns}
				/>
			</div>
		</div>
	)

}

export default Codes